'use client';

import { AnalyticsProvider as ChimeAnalyticsProvider } from '@1debit/analytics';
import { analyticsHandler, appEnvironment } from '../analytics';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import { toSnakeCase } from 'utils/formatters';

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const [formattedPageName, setFormattedPageName] = useState<string>('');
  const pathname = usePathname();

  useEffect(() => {
    // Page name needs to be in snake_case or else the event will be dropped by Analytics SDK
    // eslint-disable-next-line react-hooks/set-state-in-effect -- requires document.title which is only available in browser
    setFormattedPageName(toSnakeCase(document?.title));
  }, [pathname]);

  return (
    <>
      <ChimeAnalyticsProvider handler={analyticsHandler} pageName={formattedPageName} env={appEnvironment} />
      {children}
    </>
  );
}
